import * as React from 'react';
import { AccordionItemCore, } from '@core-front/accordion';
import { getBackgroundColorClass } from '@telia-front/colors';
import HashTrigger from '@telia-front/hash-trigger';
import VisibilityProvider from '@telia-front/visibility-provider';
import { AccordionContext, } from '../accordion/accordion';
import AccordionArrow from '../accordion-arrow/accordion-arrow';
export const AccordionItemContext = React.createContext({
    checkable: undefined,
    hideHeaderOnOpen: false,
    isMobile: false,
});
export default class AccordionItem extends React.Component {
    constructor(props) {
        super(props);
        this.headerRef = null;
        this.state = {
            headerHeight: null,
        };
    }
    componentDidMount() {
        if (this.context.hideHeaderOnOpen) {
            if (this.headerRef && this.state.headerHeight !== this.headerRef.clientHeight) {
                this.setState({
                    headerHeight: this.headerRef.clientHeight,
                });
            }
        }
    }
    backgroundColorClass() {
        const { background, type } = this.props;
        if (type === 'employee' && !background) {
            return getBackgroundColorClass('background-5');
        }
        if (background) {
            if (background === 'transparent') {
                return 'accordion__item--transparent';
            }
            else {
                return getBackgroundColorClass(background);
            }
        }
    }
    BEM() {
        const { isChecked, className } = this.props;
        const classArray = [];
        if (isChecked) {
            classArray.push('is-checked');
        }
        if (typeof isChecked !== 'undefined') {
            classArray.push('accordion__item--checkable');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    render() {
        const style = {
            minHeight: this.state.headerHeight + 'px',
        };
        const accordionItemContextValue = {
            checkable: typeof this.props.isChecked !== 'undefined',
            headerRef: (el) => this.headerRef = el,
            hideHeaderOnOpen: this.context.hideHeaderOnOpen,
            isMobile: this.context.isMobile,
        };
        return (React.createElement(AccordionItemContext.Provider, { value: accordionItemContextValue },
            React.createElement(AccordionItemCore, Object.assign({}, this.props, { className: this.BEM(), components: {
                    AccordionArrow,
                    HashTrigger,
                    VisibilityProvider,
                }, shouldRenderArrow: this.context.hideHeaderOnOpen && !this.context.isMobile, style: this.context.hideHeaderOnOpen ? style : undefined, backgroundColorClass: this.backgroundColorClass() }))));
    }
}
AccordionItem.contextType = AccordionContext;
